import { About, Contact, Footer, Header, Hero, Service, Teams } from "./components";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Service />
      <Teams />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
